import React, { useEffect, useState } from 'react'
import Select from 'react-select';
import "../../Assets/Css/Tickets.scss"
import { customStyle } from '../../Components/Style';
import CustomCalendar from '../../Components/CustomCalendar';
import Table from '../../Components/Table';
import TicketIcon from "../../Assets/Images/Tickets/TicketIcon.svg"
import { useNavigate } from 'react-router-dom';
import TicketCard from '../../Components/TicketCard';
import { getTickets, updateTicket } from '../../Services/Ticket/action';
import { connect } from 'react-redux';
import moment from 'moment';
import { deleteRecord } from '../../Services/Delete/action';
import RoleWiseFeatureWrapper, { checkFeatureAccess } from '../../Lib/RoleWiseFeatureWrapper';
import ModulesList from '../../Assets/ModulesLiist';
import FeaturesList from '../../Assets/FeaturesList';

const statusFilter = [
     { value: "All", label: "All" },
     { value: "Open Tickets", label: "Open Tickets" },
     { value: "Pending Tickets", label: "Pending Tickets" },
     { value: "Resolved Tickets", label: "Resolved Tickets" },
     { value: "Closed Tickets", label: "Closed Tickets" },
];

const Tickets = (props) => {
     const navigate = useNavigate()
     const [inData, setInData] = useState([]);
     const [filteredData, setFilteredData] = useState([]);
     const [totalTickets, setTotalTickets] = useState(0);
     const [openTickets, setOpenTickets] = useState(0);
     const [pendingTickets, setPendingTickets] = useState(0);
     const [resolvedTickets, setResolvedTickets] = useState(0);
     const [closedTickets, setClosedTickets] = useState(0);

     const canView = checkFeatureAccess({
          modules: props?.modules,
          features: props?.features,
          user: props?.user,
          ModuleName: ModulesList.Ticket,
          Featur_Name: FeaturesList.View,
     });

     const canDelete = checkFeatureAccess({
          modules: props?.modules,
          features: props?.features,
          user: props?.user,
          ModuleName: ModulesList.Ticket,
          Featur_Name: FeaturesList.Delete,
     });

     const canEdit = checkFeatureAccess({
          modules: props?.modules,
          features: props?.features,
          user: props?.user,
          ModuleName: ModulesList.Ticket,
          Featur_Name: FeaturesList.Update,
     });
     const header = [
          // { field: "checkbox" },
          { field: "Ticket#" },
          { field: "Ticket Subject" },
          { field: "Requester Name" },
          { field: "Requested On" },
          { field: "Others" },
          { field: "Status" },
          { field: "Action" },
     ];


     const fetchData = async () => {
          await props?.getTickets();
     }
     useEffect(() => {
          fetchData();
     }, []);


     useEffect(() => {
          let totalTicketsCount = 0;
          let openTicketsCount = 0;
          let closedTicketsCount = 0;
          let resolvedTicketsCount = 0;
          let pendingTicketsCount = 0;
          setInData(
               props?.ticket && props?.ticket?.sort((a, b) => new Date(b.date) - new Date(a.date)).map((item) => {
                    totalTicketsCount += 1;
                    if (item?.status == "Open") openTicketsCount += 1;
                    if (item?.status == "Closed") closedTicketsCount += 1;
                    if (item?.status == "Resolved") resolvedTicketsCount += 1;
                    if (item?.status == "Pending") pendingTicketsCount += 1;
                    return {
                         checkbox: {
                              value: item?.id,
                              type: 'checkbox',
                         },
                         "Ticket#": {
                              value: item?.id,
                              type: 'text'
                         },
                         "Ticket Subject": {
                              value: item?.subject,
                              type: 'text'
                         },
                         "Requester Name": {
                              value: item?.user?.name || item?.client?.name,
                              type: 'text'
                         },
                         "Requested On": {
                              value: item?.date?.split(" ")[0],
                              type: 'text'
                         },
                         Others: {
                              value: '-',
                              type: 'text'
                         },
                         Status: {
                              value: item.status,
                              type: "ticket_select_option",
                         },
                         Action: {
                              value2: '/ticket/view',
                              value3: item?.id,
                              value8: '/ticket/view/reply',
                              type: 'action'
                         },
                         allData: {
                              ...item
                         }
                    }
               })
          )
          setTotalTickets(totalTicketsCount);
          setOpenTickets(openTicketsCount);
          setClosedTickets(closedTicketsCount);
          setResolvedTickets(resolvedTicketsCount);
          setPendingTickets(pendingTicketsCount);
     }, [props?.ticket])

     const [Fields, setFields] = useState({
          employee: "",
          priority: "",
          channelname: "",
          type: "",
          agent: "",
          status: "",
          statusFilter: "",
     });
     const [searchTerm, setSearchTerm] = useState("");
     const [dateStatus, setDateStatus] = useState(false);
     const [filteredStartDate, setFilteredStartDate] = useState(null);
     const [filteredEndDate, setFilteredEndDate] = useState(null);

     const applyFilters = ({ startDate, endDate, status, search }) => {
          setFilteredStartDate(filteredStartDate || startDate);
          setFilteredEndDate(filteredEndDate || endDate);
          const filtered = inData?.filter((ticket) => {
               let matchesStatus = true;
               let matchesSearch = true;
               let matchesDate = true;
               const ticketSubject = ticket?.['Ticket Subject']?.value?.toLowerCase() || '';

               if ((filteredStartDate || startDate) && (filteredEndDate || endDate)) {
                    setDateStatus(true);

                    const itemStartDate = moment(ticket?.["Requested On"]?.value).startOf('day');
                    const itemDueDate = ticket?.["Requested On"]?.value
                         ? moment(ticket?.["Requested On"]?.value).startOf('day')
                         : itemStartDate;

                    const filterStart = moment(filteredStartDate || startDate).startOf('day');
                    const filterEnd = moment(filteredEndDate || endDate).endOf('day');

                    matchesDate =
                         itemStartDate.isBetween(filterStart, filterEnd, undefined, '[]') ||
                         itemDueDate.isBetween(filterStart, filterEnd, undefined, '[]');
               }

               if (status) {
                    if (status?.value != 'All') {
                         matchesStatus = ticket?.Status?.value?.toLowerCase() == status?.value?.split(" ")[0]?.toLowerCase();
                    }
               }

               if (search) {
                    matchesSearch = ticketSubject.includes(search.toLowerCase());
               }
               return matchesStatus && matchesSearch && matchesDate;
          });
          setFilteredData(filtered);
     };

     const searchFiled = (e) => {
          const { name, value } = e.target;
          setSearchTerm(value);
          applyFilters({ startDate: filteredStartDate, endDate: filteredEndDate, status: Fields?.statusFilter, search: value });
     };

     const handleClear = () => {
          setFields({
               statusFilter: ""
          });
          setSearchTerm("");
          setDateStatus(false);
          setFilteredData([]);
          setFilteredStartDate(null);
          setFilteredEndDate(null);
     }

     return (
               <div className='ticket-container'>
                    <div className="page-title">
                         <h4>Tickets</h4>
                    </div>

                    <div className='row'>
                         <div className="col-lg-4 col-md-4 col-sm-12">
                              <div className="card-type">
                                   <CustomCalendar
                                        inData={inData}
                                        setFilteredData={setFilteredData}
                                        searchTerm={searchTerm}
                                        applyFilters={(params) => { applyFilters(params) }}
                                        startDate={filteredStartDate}
                                        endDate={filteredEndDate}
                                        setStartDate={setFilteredStartDate}
                                        setEndDate={setFilteredEndDate} />
                              </div>
                         </div>

                         <div className="col-lg-4 col-md-4 col-sm-12">
                              <div className='input-group'>
                                   <Select
                                        value={Fields.statusFilter}
                                        onChange={(data) => {
                                             setFields({
                                                  ...Fields,
                                                  statusFilter: data,
                                             })
                                             applyFilters({ startDate: filteredStartDate, endDate: filteredEndDate, status: data, search: searchTerm })
                                        }}
                                        options={statusFilter}
                                        placeholder={"--"}
                                        styles={customStyle}
                                        theme={(theme) => ({
                                             ...theme,
                                             colors: {
                                                  ...theme.colors,
                                                  primary25: "#5757fe",
                                                  primary: "#5757fe",
                                             },
                                        })}
                                   />
                              </div>
                         </div>

                         <div className="col-lg-4 col-md-4 col-sm-12">
                              <div className="input-group">
                                   <input type="text" className="input-css" name='search' placeholder='Search...' value={searchTerm || ""}
                                        onChange={searchFiled} />
                              </div>
                         </div>

                         <div className='ticket-infirmation-card col-lg-12 col-md-12 col-sm-12'>
                              <div className="card-part">
                                   <TicketCard
                                        title="Total Tickets"
                                        value={totalTickets}
                                        icon={TicketIcon}
                                   />
                              </div>
                              <div className="card-part">
                                   <TicketCard
                                        title="Closed Tickets"
                                        value={closedTickets}
                                        icon={TicketIcon}
                                   />
                              </div>
                              <div className="card-part">
                                   <TicketCard
                                        title="Open Tickets"
                                        value={openTickets}
                                        icon={TicketIcon}
                                   />
                              </div>
                              <div className="card-part">
                                   <TicketCard
                                        title="Pending Tickets"
                                        value={pendingTickets}
                                        icon={TicketIcon}
                                   />
                              </div>
                              <div className="card-part">
                                   <TicketCard
                                        title="Resolved Tickets"
                                        value={resolvedTickets}
                                        icon={TicketIcon}
                                   />
                              </div>
                         </div>


                         <div className='action-part col-lg-12 col-md-12 col-sm-12'>
                              <div className="edit-btn">
                                   <RoleWiseFeatureWrapper
                                        modules={props?.modules}
                                        features={props?.features}
                                        user={props?.user}
                                        ModuleName={ModulesList.Ticket}
                                        Featur_Name={FeaturesList.Create}>

                                        <button
                                             type="submit"
                                             className="custom-btn"
                                             onClick={() => navigate('/ticket/add')}
                                        >
                                             Create Ticket
                                        </button>
                                   </RoleWiseFeatureWrapper>

                                   {/* <button
                                        type="submit"
                                        className="custom-btn"
                                   // onClick={hadleBack}
                                   >
                                        Export
                                   </button> */}

                                   {(Fields?.statusFilter || dateStatus || searchTerm) && (
                                        <button
                                             type="submit"
                                             className="custom-btn"
                                             onClick={handleClear}
                                        >
                                             Clear
                                        </button>
                                   )}
                              </div>
                         </div>

                         <div className='ticket-table col-lg-12 col-md-12 col-sm-12'>
                              <Table
                                   header={header}
                                   data={(Fields?.statusFilter || dateStatus || searchTerm) ? filteredData : inData}
                                   footer={true}
                                   count={inData.length}
                                   records={inData.length}
                                   showIsDelete={canDelete}
                                   showIsView={canView}
                                   showIsReply={true}
                                   setFields={setFields}
                                   updateTicket={props?.updateTicket}
                                   deleteRecord={props?.deleteRecord}
                              />
                         </div>

                    </div>
               </div>
     )
}

const mapStateToProps = (state) => {
     return {
          loading: state.ticketReducer.loading,
          ticket: state.ticketReducer.ticket,
          modules: state.authenticationReducer.modules,
          features: state.authenticationReducer.features,
          user: state.authenticationReducer.user,
     };
}

const mapDispatchToProps = (dispatch) => {
     return {
          getTickets: () => {
               dispatch(getTickets())
          },
          updateTicket: (id, data) => {
               dispatch(updateTicket(id, data))
          },
          deleteRecord: async (id, inputValue) => {
               await dispatch(deleteRecord(id, inputValue))
               await dispatch(getTickets())
          }
     };
}

export default connect(mapStateToProps, mapDispatchToProps)(Tickets);
